<!-- eslint-disable no-multi-assign -->
<!-- eslint-disable no-extend-native -->
<!-- eslint-disable no-tabs -->
<template>
    <div class="knobfield">
        <div :class="{'selected' : selectedValue === terms[0].term_id}" class="label" ref="labelone">{{ terms[0].name }}</div>
        <div :class="{'selected' : selectedValue === terms[2].term_id}" class="label" ref="labeltwo">{{ terms[2].name }}</div>

        <div class="inputslider" ref="inputslider">
            <div class="area" ref="area">
                <div class="track" ref="track"></div>
                <div class="knob" ref="knob"></div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    ref,
    computed,
    onMounted
} from 'vue/dist/vue.esm-bundler';

import { useStore } from 'vuex';

import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default {
    name: 'Switch',
    props: {
        terms: {
            type: Array,
            default: () => []
        },
        minwidth: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const store = useStore();
        const selectedValue = ref(null);

        const handleInputslider = (instance, snap) => {
            // console.log('instance: ', instance, 'snap: ', snap);
            const min = parseFloat(values.value[0]),
                max = parseFloat(values.value[2]),
                relativeValue = gsap.utils.mapRange(0, instance.maxX, min, max, instance.x),
                finalValue = gsap.utils.snap(values.value, relativeValue),
                snapX = gsap.utils.mapRange(min, max, 0, instance.maxX, finalValue);

            if (snap) {
                gsap.to(instance.target, {
                    duration: 0.2,
                    x: snapX,
                    onComplete: () => {
                        selectedValue.value = props.terms[finalValue];
                        store.dispatch('setTopic', {
                            term_id: props.terms[finalValue].term_id,
                            parent: props.terms[finalValue].parent
                        });
                        context.emit('changed');
                    }
                });
            } else {
                // first load set all to both
                store.dispatch('createSelectedTopics', {
                    term_id_1: props.terms[0].term_id,
                    term_id_2: props.terms[1].term_id,
                    term_id_3: props.terms[2].term_id,
                    parent: props.terms[2].parent
                });
            }
        };

        const values = computed(() => [0, 1, 2]);

        const area = ref(null);
        const knob = ref(null);
        const labelone = ref(null);
        const labeltwo = ref(null);

        const minWidth = computed(() => labelone.value.offsetWidth + labeltwo.value.offsetWidth + 150 + 128);

        const termMinWidth = computed(() => `${props.minwidth}px`);

        const storeMinWidth = () => {
            store.dispatch('addSwitchWidth', {
                id: props.terms[0].parent,
                width: minWidth.value
            });
        };

        const setupSliders = () => {
            // eslint-disable-next-line new-cap
            const dragger = new Draggable.create(knob.value, {
                type: 'x',
                edgeResistance: 1,
                bounds: area.value,
                throwProps: false,
                onDrag() {
                    handleInputslider(this, false);
                },
                onDragEnd() {
                    handleInputslider(this, true);
                },
            });
            // console.log('dragger: ', dragger);
            handleInputslider(dragger[0]);

            const min = parseFloat(values.value[0]),
                max = parseFloat(values.value[2]),
                finalValue = (min + max) / 2,
                snapX = gsap.utils.mapRange(min, max, 0, dragger[0].maxX, finalValue);

            gsap.to(dragger[0].target, { x: snapX });
        };

        onMounted(() => {
            setupSliders();
            storeMinWidth();
        });

        return {
            selectedValue,
            store,
            setupSliders,
            values,
            area,
            knob,
            labelone,
            labeltwo,
            minWidth,
            storeMinWidth,
            termMinWidth
        };
    },
};
</script>

<style lang="scss" scoped>
.knobfield {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    position: relative;
    padding: 10px 16px;

    .label {
        font-size: 14px !important;

        @media (min-width: 767px) {
            // flex: 1;
            width: calc(50% - 51px);
            // font-size: 18px !important;
            hyphens: auto;
            line-height: 1.1;

            &:nth-child(2) {
                text-align: right;
                order: 2;
            }
        }

        &.selected {
            color: #8f5af6;
        }
        &:last-of-type {
            text-align: right;
        }
    }

}

.inputslider {
    width: 100%;

    // @media (min-width: 720px) {
    //     margin: 0;
    //     transform: rotate(0);
    // }
    @media (min-width: 767px) {
        position: relative;
        width: 86px;
        margin: 0;
        transform: rotate(0);
    }

input {
    display: none;
}

.area {
        position: relative;
        height: 20px;

    .track {
        position: absolute;
        top: 50%;
        left: 0;
        background-color: #ffffff;
        width: 100%;
        height: 6px;
        border-radius: 3px;
        z-index: 1;
        transform: translateY(-50%);
    }

    .fill {
        position: absolute;
        top: 50%;
        left: 0;
        background: #AAB2BD;
        width: 0;
        height: 6px;
        border-radius: 3px;
        z-index: 2;
        transform: translateY(-50%);
    }

    .knob {
        position: absolute;
        top: 0;
        left: 0;
        background-color: #8f5af6;
        width: 20px;
        height: 20px;
        border-radius: 75px;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 7px 12px rgba(0, 0, 0, 0.12);
        z-index: 3;
    }
}
}
</style>
